import { render } from "./CityListItemLoader.vue?vue&type=template&id=4ac9b8e1"
import script from "./CityListItemLoader.vue?vue&type=script&lang=js"
export * from "./CityListItemLoader.vue?vue&type=script&lang=js"
script.render = render

export default script